import React, { Suspense } from 'react';
import { PermissionsType } from '@/common/permissionsConst';
import { Themes } from '@maxtropy/components';

const MicrogridOverview = React.lazy(() => import(/* webpackChunkName: "MicrogridOverview" */ './index'));

const routes = [
  {
    path: '/microgrid/operation/overview',
    permission: PermissionsType.P_MICROGRIDOVERVIEW_JUNZHENG,
    theme: Themes.DARK,
    element: (
      <Suspense fallback={null}>
        <MicrogridOverview />
      </Suspense>
    ),
  },
];

export default routes;
